import React, { useEffect } from "react";

const RatingCard = ({ title, rating, items, delay }) => {
  const renderStars = (count) => {
    return Array(5)
      .fill(0)
      .map((_, index) => (
        <span
          key={index}
          className={`text-2xl ${
            index < count ? "text-yellow-400" : "text-gray-300"
          }`}
        >
          ★
        </span>
      ));
  };

  return (
    <div
      className="bg-white rounded-lg shadow-sm p-4 flex-1"
      data-aos="fade-up"
      data-aos-delay={delay}
      data-aos-duration="800"
    >
      <div className="flex items-center justify-between mb-6 pb-4 border-b-2 border-red-500">
        <h2 className="text-sm md:text-md lg:text-lg font-semibold text-gray-900">
          {title}
        </h2>
        <div className="flex items-center gap-2">
          <span className="text-sm md:text-md lg:text-lg font-semibold text-red-500">
            {rating}
          </span>
          <span className="text-yellow-400 text-sm md:text-md lg:text-lg font-semibold">
            ★
          </span>
        </div>
      </div>
      <div className="space-y-4 text-xs md:text-sm text-gray-600 font-normal">
        {items.map((item, index) => (
          <div
            key={index}
            className="flex items-center justify-between"
            data-aos="fade-left"
            data-aos-delay={delay + 100 + index * 100}
            data-aos-duration="600"
          >
            <span className="text-sm md:text-md lg:text-lg font-normal">
              {item.label}
            </span>
            <div className="flex gap-1">{renderStars(item.stars)}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

const RatingsReview = () => {
  useEffect(() => {
    // Initialize AOS
    if (typeof window !== "undefined") {
      const AOS = require("aos");
      require("aos/dist/aos.css");

      AOS.init({
        once: true,
        mirror: false,
      });
    }
  }, []);

  const environmentData = {
    title: "Environment",
    rating: "4.1",
    items: [
      { label: "Neighbourhood", stars: 4 },
      { label: "Roads", stars: 3 },
      { label: "Safety", stars: 4 },
      { label: "Cleanliness", stars: 3 },
    ],
  };

  const commutingData = {
    title: "Commuting",
    rating: "4.5",
    items: [
      { label: "Public Transport", stars: 4 },
      { label: "Parking", stars: 3 },
      { label: "Connectivity", stars: 3 },
      { label: "Traffic", stars: 4 },
    ],
  };

  const placesData = {
    title: "Places of Interest",
    rating: "3.9",
    items: [
      { label: "Schools", stars: 3 },
      { label: "Hospitals", stars: 4 },
      { label: "Restaurants", stars: 4 },
      { label: "Markets", stars: 3 },
    ],
  };

  return (
    <div className="w-full">
      <div className="mx-auto">
        <h2
          className="text-lg sm:text-xl md:text-3xl font-semibold mb-1 sm:mb-2 md:mb-3 lg:mb-4 text-gray-900"
          data-aos="fade-down"
          data-aos-duration="800"
        >
          Ratings & Review
        </h2>
        <div className="flex gap-6 flex-wrap lg:flex-nowrap">
          <RatingCard {...environmentData} delay="0" />
          <RatingCard {...commutingData} delay="200" />
          <RatingCard {...placesData} delay="400" />
        </div>
      </div>
    </div>
  );
};

export default RatingsReview;
